import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Grid } from '@mui/material';
import TankerFailure from '../../components/tanker_failure';
import * as repair from '../../appRedux/actions/repair';
import BlankPage from '../../components/blank_page';
import IntlMessages from '../../util/IntlMessages';
import Comeback from '../../components/comeback';
import * as router from '../../constants/router';
import * as constants from '../../constants';
import useStyles from './styles';

function TankerFailureList(props) {
  const classes = useStyles();

  useEffect(() => {
    props.tankerRepairByOperatorAction();
  }, []);

  return (
    <React.Fragment>
      <Comeback
        redirectLink={router.TANKER_FAILURE}
        title={<IntlMessages id="comeback" />}
      />
      <Grid className={classes.rootList}>
        {props.list.length === 0 ? (
          <BlankPage type={constants.BLANK_PAGE_CAR_REPAIR} />
        ) : (
          props.list.map((obj, index) => <TankerFailure key={index} {...obj} />)
        )}
        <br />
        <br />
        <br />
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    list: state.field.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    tankerRepairByOperatorAction: () => dispatch(repair.tankerRepairByOperatorAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TankerFailureList);
